import api from "config/axios.config";
import { Content, DateVolunteer, UploadContent } from "./content.type";

interface UploadMapImageResponse {
  link1: string;
}

export const findAllDateVolunteer = (): Promise<DateVolunteer[]> => {
  return api.get(`/dateVolunteer`);
};

export const findAllContents = (): Promise<Content[]> => {
  return api.get(`/content`);
};

export async function updateContents(contents: Content[]) {
  return api.patch(`content/bulk`, contents);
}

export async function updateDateVolunteer(dateVolunteer: DateVolunteer[]) {
  return api.patch(`dateVolunteer/bulk`, dateVolunteer);
}

export async function uploadMapImage({ id, file }: UploadContent): Promise<UploadMapImageResponse> {
  const formData = new FormData();
  formData.append("file", file);
  return await api.patch<never, UploadMapImageResponse>(`/content/map/${id}/image`, formData);
}

interface UploadSubContentImageResponse {
  image: string;
}

export async function uploadSubContentImage({ id, file }: UploadContent): Promise<UploadSubContentImageResponse> {
  const formData = new FormData();
  formData.append("file", file);
  return await api.patch<never, UploadSubContentImageResponse>(`/subContent/${id}/image`, formData);
}

interface UploadContentImageResponse {
  image: string;
}

export async function uploadContentImage({ id, file }: UploadContent): Promise<UploadContentImageResponse> {
  const formData = new FormData();
  formData.append("file", file);
  return await api.patch<never, UploadContentImageResponse>(`/content/${id}/image`, formData);
}



